import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './qualificationForm';
import List from './qualificationList';

const settings = {
    pathRegister: paths.qualificationRegister,
    pathList: paths.qualification,
    apiPath: 'qualifications',
    permissionAdmin: null,
    title: 'Qualificação',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Qualificações' }} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
